module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Gd-Hc-Ic-Jb.1a413269.png";